import React from 'react';
import Grid from '@mui/material/Grid2';

interface Props { }

const DelegateCertification: React.FC<Props> = () => {

  const knackUrl = 'https://awa.knack.aft.org/conventionforms#credential-reporting/';

  return (
    <div>
      <Grid size={{ xs: 12, md: 12 }}>
        <h2>Delegate Certification</h2>
      </Grid>
      <iframe
        src={knackUrl}
        width="100%"
        height="1200px"
        frameBorder="0"
        title="Knack Embed"
      />
    </div>
  );
};

export default DelegateCertification;
